import ChangePhoneNumberProcess from './change-phone-number-process';

export default ChangePhoneNumberProcess;

